import { createSelector, createFeatureSelector } from '@ngrx/store';
import { settingsFeatureKey, SettingsState } from './settings.reducer';

export const settingsFeatureSelector = createFeatureSelector<SettingsState>(settingsFeatureKey);

export const getSettings = createSelector(
  settingsFeatureSelector,
  (state: SettingsState) => state.settings
);
